import { render, staticRenderFns } from "./VersionTracker.vue?vue&type=template&id=8015834c"
import script from "./VersionTracker.vue?vue&type=script&lang=ts"
export * from "./VersionTracker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports